import { render, staticRenderFns } from "./UploadDocumentForm.vue?vue&type=template&id=29b21aa1&scoped=true&"
import script from "./UploadDocumentForm.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b21aa1",
  null
  
)

export default component.exports